<template>
  <div id="header">
    <!-- <v-row> -->
    <v-btn
      class="mb-2 px-0"
      text
      small
      @click="$router.push({ name: 'settings' })"
    >
      <v-icon small>
        mdi-arrow-left
      </v-icon>
      Go back
    </v-btn>
    <!-- </v-row> -->

    <h3 class="primary--text mb-5">
      Welcome, {{ user.first_name }}
    </h3>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PageHeader',

  data: () => ({}),

  computed: {
    ...mapState({
      user: (state) => state.account.user,
    }),
  },
};
</script>
